var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAccordionDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_accordion_down") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Details-01",
    transform: "translate(-349.000000, -835.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(349.000000, 799.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_accordion_down",
    transform: "translate(12.000000, 48.000000) scale(1, -1) translate(-12.000000, -48.000000) translate(0.000000, 36.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#95C11F",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,11.369069 C15.0006246,11.6859814 14.8749314,11.9900779 14.6507336,12.2140628 L10.3509547,16.5138417 C10.0384085,16.8163997 9.54096214,16.8123611 9.2333695,16.5047685 C8.92577686,16.1971758 8.92173831,15.6997295 9.2242963,15.3871833 L13.1626432,11.4488364 C13.1838338,11.4276993 13.1957431,11.3989992 13.1957431,11.369069 C13.1957431,11.3391388 13.1838338,11.3104386 13.1626432,11.2893016 L9.2242963,7.35095465 C8.92173831,7.03840846 8.92577686,6.54096214 9.2333695,6.2333695 C9.54096214,5.92577686 10.0384085,5.92173831 10.3509547,6.2242963 L14.6507336,10.5240752 C14.8749314,10.7480601 15.0006246,11.0521566 15,11.369069 L15,11.369069 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    transform: "translate(12.000000, 11.369069) scale(1, -1) rotate(-270.000000) translate(-12.000000, -11.369069) "
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAccordionDown);
export default __webpack_public_path__ + "static/media/icon_accordion_down.a3406f2a831292d71deb721fd5123405.svg";
export { ForwardRef as ReactComponent };